"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkIIMQROIVcjs = require('./chunk-IIMQROIV.cjs');


var _chunkQBYZPWDOcjs = require('./chunk-QBYZPWDO.cjs');

// src/contracts/core/JettonMinter.ts
var _ton = require('@ton/ton');
var JettonMinter = class extends _chunkIIMQROIVcjs.Contract {
  async getWalletAddress(provider, ownerAddress) {
    const result = await provider.get("get_wallet_address", [
      {
        type: "slice",
        cell: _ton.beginCell.call(void 0, ).storeAddress(_chunkQBYZPWDOcjs.toAddress.call(void 0, ownerAddress)).endCell()
      }
    ]);
    return result.stack.readAddress();
  }
  async getJettonData(provider) {
    const result = await provider.get("get_jetton_data", []);
    const jettonData = {
      totalSupply: result.stack.readBigNumber(),
      canIncSupply: Boolean(result.stack.readNumber()),
      adminAddress: result.stack.readAddressOpt(),
      contentRaw: result.stack.readCell(),
      jettonWalletCode: result.stack.readCell()
    };
    return jettonData;
  }
};



exports.JettonMinter = JettonMinter;
//# sourceMappingURL=chunk-WF6EZ2CW.cjs.map